import { useHotkeys } from 'react-hotkeys-hook'
import { ShortcutAction, ShortcutActions } from 'data/shortcuts'

type HotkeyOptions = Parameters<typeof useHotkeys>[2]

const defaultOptions: HotkeyOptions = {
    preventDefault: true,
    enableOnFormTags: true,
    enableOnContentEditable: true,
    ignoreEventWhen: (event) => {
        const target = event.target as HTMLElement

        // Check if we're in an input field, textarea, or contentEditable element
        const isInInputField =
            target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable ||
            target.closest('[contenteditable="true"]')

        if (!isInInputField) {
            return false // Allow all shortcuts when not in input fields
        }

        // When in input fields, only block single-key shortcuts (no modifiers)
        // Allow modifier-based shortcuts like Mod+B, Mod+I, Mod+Enter, etc.
        const hasModifier = event.metaKey || event.ctrlKey || event.altKey || event.shiftKey

        if (hasModifier) {
            return false // Allow shortcuts with modifiers (Mod+B, Mod+I, etc.)
        }

        // Block single-key shortcuts when typing
        return true
    },
}

export const useShortcut = (
    name: ShortcutAction,
    callback: () => void,
    options: Parameters<typeof useHotkeys>[2] = {},
    dependencies?: Parameters<typeof useHotkeys>[3],
) => {
    const shortcut = ShortcutActions[name]
    useHotkeys(shortcut.keys, callback, { ...defaultOptions, ...options }, dependencies)
    return callback
}
